module.exports = __webpack_public_path__ + "static/DragoneEX-a377f7a3822f37cc9867cc4f2c831012.png";